import localScaleManager from "../../../../helpers/LocalScaleManager";

export default class RaiseWheel extends Phaser.GameObjects.Image {
  constructor(scene, parent, table) {
    super(scene, 0, 0, scene.atlasTexture, "raise-up-layer");
    this.setOrigin(0);
    this.scene = scene;
    this.parent = parent;
    this.table = table;
    this.scene.add.existing(this);
    this.table.poolArray.push(this);

    this.chip = this.scene.add
      .image(0, 0, this.scene.atlasTexture, "raise-chip")
      .setInteractive({ cursor: "pointer" });
    this.table.poolArray.push(this.chip);

    this.setInteractive();
    this.parent.menuBg.setInteractive();

    this.shape = this.scene.make.graphics();
    this.shape.fillStyle(0xffffff);
    this.startSwiping = false;
    this.minHeight = 0;
    this.maxHeight = 0;
    // this.rolling = false;
    // const config = {
    //     key: `wheelGoRound`,
    //     frames: this.scene.anims.generateFrameNumbers('wheel', {
    //         start: 0,
    //         end: 2,
    //     }),
    //     // frameRate: 12,
    //     repeat: -1,
    // };
    // this.scene.anims.create(config);
    this.on("pointerdown", (pointer) => {
      this.startSwiping = true;
      this.fill(pointer);
    });
    this.parent.menuBg.on("pointerdown", (pointer) => {
      this.startSwiping = true;
      this.fill(pointer);
    });
    this.chip.on("pointerdown", (pointer) => {
      this.startSwiping = true;
      this.fill(pointer);
    });
    this.scene.input.on("pointermove", (pointer) => {
      this.fill(pointer);
    });
    this.scene.input.on("pointerup", (pointer) => {
      this.startSwiping = false;
    });
    this.on("pointerup", (pointer) => {
      this.startSwiping = false;
    });
    this.parent.menuBg.on("pointerup", (pointer) => {
      this.startSwiping = false;
    });
    // this.scene.input.on('pointerout', () => {
    //     this.startSwiping = false;
    // });
  }
  fill(pointer) {
    if (this.startSwiping) {
      let yLevel = 0;
      if (pointer.y > this.maxHeight && pointer.y < this.minHeight) {
        yLevel = pointer.y;
      } else if (pointer.y <= this.maxHeight) {
        yLevel = this.maxHeight;
      } else if (pointer.y >= this.minHeight) {
        yLevel = this.minHeight;
      }
      this.updateRaiseAmount(yLevel);

      this.shape.clear();
      this.chip.setY(yLevel);
      let filledPart = this.displayHeight;
      this.shape.fillRect(this.x, yLevel, this.displayWidth, filledPart);
      this.shape.fillPath();
    }
  }
  updateRaiseAmount(y) {
    const maxRaise = this.parent.maxRaise;
    const minRaise = this.parent.minRaise;
    const amount =
      ((this.minHeight - y) * (maxRaise - minRaise)) /
      (this.minHeight - this.maxHeight);
    // this.parent.menuInput.setValue((Math.round(amount) + minRaise === this.parent.userBalance) ? 'Allin' : Math.round(amount) + minRaise);
    this.parent.menuInput.setValue(Math.round(amount) + minRaise);
  }
  fillByAmount(amount) {
    const maxRaise = this.parent.maxRaise;
    const minRaise = this.parent.minRaise;
    let yLevel = 0;
    if (amount > minRaise && amount < maxRaise) {
      yLevel =
        this.minHeight -
        ((amount - minRaise) * (this.minHeight - this.maxHeight)) /
          (maxRaise - minRaise);
    } else if (amount >= maxRaise) {
      yLevel = this.maxHeight;
    } else if (amount <= minRaise) {
      yLevel = this.minHeight;
    }
    // }
    this.shape.clear();
    if (this.chip.y !== yLevel) {
      this.chip.setY(yLevel);
    }

    let filledPart = this.displayHeight;
    this.shape.fillRect(this.x, yLevel, this.displayWidth, filledPart);
    this.shape.fillPath();
  }
  // startRoll(){
  //     this.rolling = true;
  // }
  // doRoll(pointer) {
  //     if (this.allowSwiping && this.rolling) {
  //         this.anims.pause();
  //         const deltaY = pointer.downY - pointer.y;
  //         const deltaTime = pointer.time - pointer.downTime;
  //         if(deltaY > 0) { /*ro be bala*/
  //             if(!this.anims.isPlaying) {
  //                 if (this.parent.inputValue < this.parent.maxRaise) {
  //                     this.parent.menuInput.setValue(this.parent.inputValue + this.parent.table.tableInfo.bigBlinds);
  //                     this.play(`wheelGoRound`);
  //                     this.anims.stopAfterDelay(deltaTime);
  //                 }
  //             }
  //         }
  //         else if(deltaY < 0) { /*ro be paeen*/
  //             if(!this.anims.isPlaying) {
  //                 if(this.parent.inputValue > this.parent.minRaise) {
  //                     this.parent.menuInput.setValue(this.parent.inputValue - this.parent.table.tableInfo.bigBlinds);
  //                     this.anims.playReverse("wheelGoRound");
  //                     this.anims.stopAfterDelay(deltaTime);
  //                 }
  //             }
  //         }
  //     }
  // }
  // stopRoll() {
  //     this.rolling = false;
  //     // this.anims.stopAfterDelay(0);
  // }
  /**
   *
   * @param scale -> raise menu bg scale
   * @param initX -> raise menu x
   * @param initY -> raise menu y
   */
  positionControls(scale, initX, initY) {
    localScaleManager.scaleSpriteTo(this, scale);
    this.setPosition(initX, initY);

    let chipSize = this.displayWidth / 2;
    localScaleManager.scaleSprite(this.chip, chipSize, chipSize, 0, 1, true);
    this.chip.setPosition(
      initX + this.displayWidth / 2,
      initY + this.displayHeight - this.chip.displayHeight / 2
    );
    this.minHeight = this.chip.y;
    this.maxHeight = this.y;

    this.shape.fillRect(
      this.x,
      this.y + this.displayHeight,
      this.displayWidth,
      0
    );

    this.shape.fillPath();

    this.mask = this.shape.createGeometryMask();

    this.setMask(this.mask);
  }
  /**
   *
   * @param initX -> raise menu x
   * @param initY -> raise menu y
   */
  reposition(initX, initY) {
    this.setPosition(initX, initY);

    this.chip.setPosition(
      initX + this.displayWidth / 2,
      initY + this.displayHeight - this.chip.displayHeight / 2
    );
    this.minHeight = this.chip.y;
    this.maxHeight = this.y;

    this.shape.fillRect(
      this.x,
      this.y + this.displayHeight,
      this.displayWidth,
      0
    );

    this.shape.fillPath();

    this.mask = this.shape.createGeometryMask();

    this.setMask(this.mask);
  }
  remove() {
    this.destroy();
  }
}
